<template>
    <a-card :bordered="false">
        <a-button class="m-b-20" type="primary" v-has:guideGiftAdd="()=>{$router.push('/guide/shoppingGuide/guide_add?type=add')}">新建礼品</a-button>
         <a-tabs v-model:activeKey="form.status" @change="form.page=1;selectedRowKeys=[];getGiftList()">
           <a-tab-pane :key="1" tab="已上架"></a-tab-pane>
           <a-tab-pane :key="0" tab="未上架"></a-tab-pane>
         </a-tabs>
         <a-form layout='inline'>
             <a-form-item label="关键字">
                <a-input type="text" v-model:value="form.keyword" style="width:220px" placeholder="请输入关键字进行搜索"></a-input>
             </a-form-item>
              <a-form-item label="兑换状态">
                 <a-select v-model:value="form.exchange_status" style="width:120px">
                     <a-select-option value="">全部</a-select-option>
                     <a-select-option :value="1">正常</a-select-option>
                     <a-select-option :value="2">已兑完</a-select-option>
                 </a-select>
             </a-form-item>
             <a-form-item label="分类">
                 <a-select v-model:value="form.gift_category_id" style="width:120px">
                     <a-select-option value="">全部</a-select-option>
                     <a-select-option :value="item.id" v-for="(item,index) in category_list" :key="index">{{item.name}}</a-select-option>
                 </a-select>
             </a-form-item>
             <a-form-item>
                 <a-button type="primary" @click="form.page=1;pagination.current=1;getGiftList()">搜索</a-button>
             </a-form-item>
         </a-form>
         <div class="s_flex_ali m-t-20">
              <a-button type="primary" ghost @click="setShelvesAll">{{form.status==0?'批量上架':'批量下架'}}</a-button>
              <a-button type="primary" class="m-l-15" ghost @click="setFreight">批量设置运费</a-button>
         </div>
         <a-table :columns='columns' rowKey='id' :pagination="pagination" :data-source='list' class="tableFixBox m-t-20" :scroll="{ x: 'max-content'}" bordered :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" @change="changePage">
             <template v-slot:priceData="{record}">
                 <div>
                     <div v-if="record.price_type.some((v)=>v=='1')">
                         <span class="m-r-5 s_cd41">{{record.first_point || 0}} 积分</span>
                         <FormOutlined v-if="!record.price_type.some((v)=>v=='2')" @click="openGiftEditPrice(record)" class="m-l-5" style="color:#05486a;"/>
                     </div>
                     <div v-if="record.price_type.some((v)=>v=='2')">
                         <span class="m-r-5 s_cd41" >{{record.second_point || 0}} 积分</span>
                         <span class="m-r-5 s_cd41" > + ￥{{record.second_price || '0.00'}}</span>
                         <FormOutlined @click="openGiftEditPrice(record)" class="m-l-5" style="color:#05486a;"/>
                     </div>
                 </div>
             </template>
             <template v-slot:gift="{record}">
                 <div class="s_flex_ali">
                     <img :src="info.picdomain+'/'+record.gift_image" style="width:60px;height:60px;border:1px solid #eee;border-radius:6px"/>
                     <span class="m-l-10 s_omit2">{{record.gift_name || '无'}}</span>
                 </div>
             </template>
            <template #action="{record}">
                 <div>
                     <a-button type="primary" size="small" ghost v-has:guideGiftEdit="()=>{$router.push('/guide/shoppingGuide/guide_edit?type=edit&id='+record.id)}">编辑</a-button>
                     <a-button type="primary" size="small" class="m-l-15" v-has:guideGiftShelves="()=>{setShelves(record)}">{{form.status==0?'上架':'下架'}}</a-button>
                     <a-button type="primary" size="small" class="m-l-15" danger v-if="form.status==0" v-has:guideGiftDelete="()=>{deleteGift(record)}">删除</a-button>
                 </div>
            </template>
         </a-table>
           <!-- 修改价格 -->
          <a-modal :keyboard="false" title="修改礼品价格" destroyOnClose v-model:visible="priceVisible" :width="800" @ok="confirm">
              <div>
                  <p class="s_ptb0lr24 s_flex_ali s_bf58 s_c333" style="font-size:16px;line-height:40px">礼品信息</p>
                   <div class="s_flex_ali p-20">
                       <div class="flex_2 s_flex_ali">
                           <img :src="info.picdomain+'/'+goodData.gift_image" class="s_bor10" style="width:60px;height:60px">
                           <span class="m-l-10 s_lin_h30 s_omit2">{{goodData.gift_name}}</span>
                       </div>
                        <div class="flex_2"></div>
                       <div class="flex_1">
                           <p class="s_lin_h30 s_cd41" v-if="goodData.price_type.some((v)=>v=='1')">{{goodData.first_point || 0}} 积分</p>
                           <p class="s_lin_h30 s_cd41" v-if="goodData.price_type.some((v)=>v=='2')">{{goodData.second_point || 0}} 积分 + ￥{{goodData.second_price || '0.00'}}</p>
                       </div>
                   </div>
                   <p class="s_ptb0lr24 s_flex_ali s_bf58 s_c333" style="font-size:16px;line-height:40px">兑换价格</p>
                   <template v-if="goodData.price_type.some((v)=>v=='1')">
                      <div class="p-l-20 m-t-20">
                          <a-input-number v-model:value="goodData.first_point" :precision="0" :min="0" placeholder="请输入兑换积分" style="width:300px;"></a-input-number>
                          <span class="m-l-10">积分</span>
                      </div>
                   </template>
                   <template v-if="goodData.price_type.some((v)=>v=='2')">
                      <div class="s_flex_ali p-l-20 m-t-20">
                          <a-input-number v-model:value="goodData.second_point" :precision="0" :min="0" placeholder="请输入兑换积分" style="width:180px;"></a-input-number>
                          <span class="m-l-10 m-r-10">积分 +</span>
                          <a-input-number v-model:value="goodData.second_price" :precision="2" :min="0.01" placeholder="请输入兑换积分" style="width:180px;"></a-input-number>
                          <span class="m-l-10">元</span>
                      </div>
                   </template>
              </div>
          </a-modal>
          <!-- 运费 -->
          <a-modal :keyboard="false" title="修改礼品价格" destroyOnClose v-model:visible="showFreight" :footer="null" :width="1000">
              <freight v-on:select="selectFreight"></freight>
          </a-modal>
    </a-card>
</template>

<script>
import {FormOutlined} from '@ant-design/icons-vue';
import { onMounted, reactive, ref, toRefs } from 'vue'
import { message,Modal } from "ant-design-vue";
import {giftList,getCategoryList,giftStatus,giftDelete,giftAllStatus,giftAllDelivery,giftEditPrice} from "@/api/guide";
import { iscode } from '../../../utils/app';
import store from "@/store";
export default{
    components:{FormOutlined},
    setup(){
        const form = ref({
            page:1,
            limit:10,
            status:1,
            keyword:'',
            exchange_status:'',
            gift_category_id:''
        })
        const state = reactive({
            info: store.state.user.info,
            activeKey:1,
            selectedRowKeys:[],
            priceVisible:false,
            showFreight:false,
            list:[],
            category_list:[],
            goodData:{
                second_point:'',
                second_price:'',
                first_point:'',
                price_type:[]
            },
             pagination: {
                 total: 0,
                 current: 1,
                 pageSize: 5,
                 defaultPageSize: 5,
                 showSizeChanger: true,
                 pageSizeOptions: ["5", "10", "15", "20"],
                 showQuickJumper: true,
                 showTotal: (total) => `共 ${total} 条`,
               },
                columns : [
              {
                  title: "礼品信息",
                  dataIndex: "gift_name",
                  key: "gift_name",
                  slots:{customRender:'gift'}
              },
              {
                  title: "规格",
                  dataIndex: "gift_sku_name",
                  key: "gift_sku_name",
                   width:120
              },
              {
                  title: "分类",
                  dataIndex: "gift_category_name",
                  key: "gift_category_name",
              },
              {
                  title: "兑换价格",
                  dataIndex: "second_price",
                  key: "second_price",
                  minWidth:120,
                  slots:{customRender:'priceData'}
              },
              {
                  title: "可兑数量",
                  dataIndex: "gift_num",
                  key: "gift_num",
                   width:120
              },
              {
                  title: "已兑换数量",
                  dataIndex: "exchange_num",
                  key: "exchange_num",
                   width:120
              },
              {
                  title: "状态",
                  dataIndex: "exchange_status",
                  key: "exchange_status",
                   width:120
              },
              {
                  title: "操作",
                  dataIndex: "action",
                  key: "action",
                  slots:{customRender:'action'},
                  width:260,
                  fixed:'right'
              },
          ]
        })
        const methods= {
            onSelectChange(selectedRowKeys){
              state.selectedRowKeys = selectedRowKeys;
            },
            setShelves(record){
                 Modal.confirm({
                 centered: true,
                 title:'提示',
                 content: `确定要${form.value.status==0?'上架':'下架'}该礼品吗？`,
                 onOk: async () => {
                      const hide = message.loading("正在加载中...", 0);
                      let res = await giftStatus({id:record.id}).then(res=>res.data)
                       setTimeout(hide)
                      if(iscode(res,true)){
                          methods.getGiftList()
                      }
                 }
                })
            },
            setFreight(){
                if(state.selectedRowKeys.length==0) return message.error('请选择礼品！')
                state.showFreight = true;
                 
            },
           async selectFreight(e){
               state.showFreight = false;
                const hide = message.loading("正在加载中...", 0);
                let res = await giftAllDelivery({ids:state.selectedRowKeys,freight_tmp_id:e.id}).then(res=>res.data)
                 setTimeout(hide)
                 if(iscode(res,true)){
                    state.selectedRowKeys = [];
                     methods.getGiftList()
                 }
            },
            async getGiftList(){
                // const hide = message.loading("正在加载中...", 0);
                state.loading = true;
                state.list = [];
                let res = await giftList({...form.value}).then(res=>res.data)
                state.loading = false;
                //  setTimeout(hide)
                if(iscode(res)){
                 console.log(res);
                 state.list = res.data.data || [];
                 state.pagination.total = res.data.total || 1;
                }else{
                    message.error(res.msg)
                }
            },
           async categoryList(){
                let res = await getCategoryList({limit:1000,page:1}).then(res=>res.data);
                if(iscode(res)){
                     state.category_list = res.data.data || [];
                     state.pagination.current = res.data.current_page;
                     state.pagination.total = res.data.total;
                }else{
                    message.error(res.msg)
                }
            },
            changePage(e){
                console.log(state.columns)
                state.pagination.current = e.current;
                state.pagination.pageSize = e.pageSize;
                form.value.page = e.current;
                form.value.limit = e.pageSize;
                methods.getGiftList()
            },
            deleteGift(record){
                 Modal.confirm({
                 centered: true,
                 title:'提示',
                 content: `确定要删除该礼品吗？`,
                 onOk: async () => {
                      const hide = message.loading("正在加载中...", 0);
                      let res = await giftDelete({id:record.id}).then(res=>res.data)
                       setTimeout(hide)
                      if(iscode(res,true)){
                          methods.getGiftList()
                      }
                 }
                })
            },
            setShelvesAll(){
                if(state.selectedRowKeys.length==0) return message.error('请选择礼品！')
                Modal.confirm({
                 centered: true,
                 title:'提示',
                 content: `确定要批量${form.value.status==0?'上架':'下架'}该礼品吗？`,
                 onOk: async () => {
                      const hide = message.loading("正在加载中...", 0);
                      let res = await giftAllStatus({ids:state.selectedRowKeys}).then(res=>res.data)
                       setTimeout(hide)
                      if(iscode(res,true)){
                          state.selectedRowKeys = [];
                          methods.getGiftList()
                      }
                 }
                })
            },
            openGiftEditPrice(record){
                  state.goodData = JSON.parse(JSON.stringify(record));
                  state.priceVisible=true;
            },
           async confirm(){
               const hide = message.loading("正在加载中...", 0);
                 let res = await giftEditPrice({...state.goodData}).then(res=>res.data)
                 setTimeout(hide)
                 if(iscode(res,true)){
                    methods.getGiftList()
                    state.priceVisible=false;
                 }
            }
            
        }
        onMounted(()=>{
            methods.categoryList()
            methods.getGiftList()
        })
        return {
            ...toRefs(state),
            form,
            ...methods
        }
    }
}
</script>
